import { render, staticRenderFns } from "./VimeoLiveStream.vue?vue&type=template&id=06534a2c&scoped=true&lang=pug&"
import script from "./VimeoLiveStream.vue?vue&type=script&lang=js&"
export * from "./VimeoLiveStream.vue?vue&type=script&lang=js&"
import style0 from "./VimeoLiveStream.vue?vue&type=style&index=0&id=06534a2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06534a2c",
  null
  
)

export default component.exports